import React, { useEffect, useState } from "react";

import StarImage from '../../assets/Home/StarImage.svg'

// css
import "./Carousel.css";
import { observer } from "mobx-react";
import General from '../../stores/GeneralStore'
import { useNavigate } from "react-router-dom";
import constants from "../../utils/constants";
import StarOutlinedIcon from "@mui/icons-material/StarOutlined";
import StarBorderOutlined from "@mui/icons-material/StarBorderOutlined";
import User from "../../stores/UserStore";
import StarIcon from "@mui/icons-material/Star";
import { toJS } from "mobx";

const CrouselCard2 = ({ element,setValue,setInnerValue,fromRecent,favourites }) => {
    const navigate = useNavigate();
    const contrast=General?.contrast;
    const renderFavourites = (element) => {
       
              if (
                element?.serviceGuidePageLink == "complaint" ||
                element?.serviceGuidePageLink == "complaints"
              ) {
                navigate("/complaint");
              }
              if (element?.serviceGuidePageLink == "movein") {
                navigate(`/movein-registration`);
              } else if (element?.serviceGuidePageLink == "moveout") {
                navigate(`/moveout-termination`);
              } else if (element?.serviceGuidePageLink == "refund") {
                navigate(`/refund`);
              } else if (element?.serviceGuidePageLink == "applyforwwpr") {
                window.open(`${constants.URL.CUSTOMER_PORTAL}`);
              } else if (element?.serviceGuidePageLink == "paymentfacilities") {
                navigate(`/payment-plan`);
              } else if (element?.serviceGuidePageLink == "billenquiry") {
                setValue(1);
              } else if (element?.serviceGuidePageLink == "billpayment") {
                setValue(1);
                setInnerValue(1);
              } else if (element?.serviceGuidePageLink == "Suggestionscomplaint") {
                navigate(`/complaint`);
              } else if (element?.serviceGuidePageLink == "sccd") {
                navigate(`/social-case-consideration`);
              } else if (
                element?.serviceGuidePageLink == "tenantnoc" ||
                element?.serviceGuidePageLink == "ownernoc"
              ) {
                navigate(`/noc-apply`,{state:{login:false}});
              }
          
      };
      const handleRemoveFavourite = async (serviceId) => {
        await User.removeFavourite(serviceId);
      };
    return (
        <div onClick={()=>renderFavourites(element)}  className="div d-flex w-100   mb-3" style={{ height: "44px",}}>

            <div className="row p-0 m-0 d-flex w-100 bg-light justify-content-between">

                <div className="col-12 d-flex justify-content-between align-items-center px-2" style={{backgroundColor: contrast?.contrastBackground?contrast?.contrastBackground:"rgba(229, 239, 242, 0.7)", color: contrast?.contrastColor?contrast?.contrastColor:'',  }}>
                    <div>
                        <p  style={{ fontSize: `${0.5 * General.accessibility.fontSize}rem`,color:contrast?.contrastColor?contrast?.contrastColor:"" }} className={`slider-text1 mb-0 pr-2 ${General?.textClass}`}>{element.serviceGuideTitle}</p>
                    </div>
                    {!fromRecent}
                {!fromRecent?<>
                    {element?.isFavorite ? (
                        <StarIcon
                        sx={{color:'#62AA51'}}
                          onClick={(e) => {
                            e.stopPropagation();
                            User.addFavourite(element?.serviceGuideId);
                          }}
                        />
                      ) : (
                        <StarBorderOutlined
                          onClick={(e) => {
                            e.stopPropagation();
                            User.addFavourite(element?.serviceGuideId);
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                </>:<>
                {favourites[element.serviceGuideId] ? (
                        <StarIcon
                        sx={{color:'#62AA51'}}
                          onClick={(e) => {
                            e.stopPropagation();
                            User.addFavourite(element?.serviceGuideId);
                          }}
                        />
                      ) : (
                        <StarBorderOutlined
                          onClick={(e) => {
                            e.stopPropagation();
                            User.addFavourite(element?.serviceGuideId);
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                </>}
                
                      
                     
                </div>

            </div>

        </div>

    );
};

export default observer(CrouselCard2);
